const ONBOARDING_STEPS = {
  SURVEY: 0,
  PERSONAL_INFOS: 1,
  CONSULTATION: 2,
  PAYMENT: 3,
  SURVEY_FINISH: 4,
}

export default ONBOARDING_STEPS
